import { since } from './version';
import { setPress, summerK } from './com';
import { setPress5 } from './opp5';
import {EQW,WEIGHT} from '../content/axes';
import {NEED} from '../content/consts';
import {ISSUES} from '../content/issues';
import {OUTLETS,PARTIES} from '../content/parties';
import {DM} from '../content/settings';
import {approval,btVote,enact,poll} from './govern';
import {rnd} from './rng';
import {PA,PN,score,scoreRaw} from './rules';
import {S,log} from './state';
import {clamp} from './util';
import {humanPids,versusOnBill} from './versus';
import {issuesNow} from './axes';

export function press(o?:any,t?:any,tone?:any){S.news.unshift({m:S.m,o,t,tone});if(S.news.length>30)S.news.pop();S.press=clamp((S.press||0)+tone*.8*summerK(),-6,6)}
setPress(press);setPress5(press);
export function mediaOnLaw(L?:any){
  const r=OUTLETS.map((o:any)=>({o,s:scoreRaw(o.pos,EQW,L.fx.pos)})).sort((a:any,b:any)=>Math.abs(b.s-.55)-Math.abs(a.s-.55));
  r.slice(0,2).forEach(({o,s}:{o:{n:string};s:number})=>{const t=L.t;
    if(s>=.62)press(o.n,[`„${t}“: Endlich packt die Regierung an`,`Lob für „${t}“: Ein überfälliger Schritt`,`Gute Nachricht: „${t}“ ist beschlossen`][L.id%3],1);
    else if(s<.45)press(o.n,[`Teurer Irrweg: Kritik an „${t}“ wächst`,`„${t}“ geht an den Problemen vorbei`,`Verbände warnen vor Folgen von „${t}“`][L.id%3],-1);
    else press(o.n,`„${t}“ beschlossen: ein Kompromiss mit Licht und Schatten`,0)});
}
export function oppParties(){return S.res.inP.filter((id)=>id!=='YOU'&&!S.partners.includes(id))}
export function leader(){return oppParties().sort((a:any,b:any)=>S.res.seats[b]-S.res.seats[a])[0]}
export function oppDraft(pid?:any){
  const cand=issuesNow().filter((i:any)=>S.issues[i.id].on&&!S.issues[i.id].law);if(!cand.length)return null;
  const I=cand[Math.floor(rnd()*cand.length)],tk=Math.floor(rnd()*I.laws.filter((x:any)=>!x.custom).length),T=I.laws[tk],P=PARTIES[pid];
  const p=Object.fromEntries(T.ps.map((x:any)=>[x.id,x.d]));
  for(let k=0;k<2;k++)for(const pa of T.ps){
    const vals=pa.k==='r'?[pa.min,Math.round((pa.min+pa.max)/2/pa.st)*pa.st,pa.max]:pa.k==='c'?pa.o.map((_:string,i:number)=>i):[0,1];
    let best=p[pa.id],bs=-1;for(const v of vals){p[pa.id]=v;const s=scoreRaw(P.pos,P.w,T.fx(p).pos);if(s>bs){bs=s;best=v}}p[pa.id]=best}
  return{pid,iss:I.id,tpl:tk,t:T.t,r:T.r,br:T.br,p,fx:T.fx(p),m:S.m};
}
export function opposition(){
  const opp=oppParties();if(!opp.length)return false;
  if(S.oppBill&&S.m-S.oppBill.m>=3){log(`Der Antrag der ${PA(S.oppBill.pid)} zu „${S.oppBill.t}“ wurde ohne Mehrheit abgelehnt.`);S.oppBill=null}
  const hum=humanPids(),human=opp.some((id)=>hum.includes(id)),ki=opp.filter((id)=>!hum.includes(id));
  const lead=ki.sort((a,b)=>S.res.seats[b]-S.res.seats[a])[0]||leader(),a=approval();
  // Konstruktives Misstrauensvotum gegen schwache Minderheitsregierungen (mit menschlicher Opposition löst sie es selbst aus)
  if(!human&&S.minority&&a<36&&rnd()<.18){
    const bloc=opp.filter((id:string)=>id!=='HO'),seats=bloc.reduce((s:number,id:string)=>s+S.res.seats[id],0);
    if(seats>=NEED){S.end='misstrauen';S.endBy=bloc;log(`Konstruktives Misstrauensvotum: ${bloc.map(PA).join(', ')} wählen eine neue Regierung.`,'bad');press(OUTLETS[0].n,'Regierung gestürzt: Opposition setzt Misstrauensvotum durch',-2);return true}
    log(`Misstrauensantrag der Opposition scheitert. Die Opposition findet keine gemeinsame Mehrheit.`);press(OUTLETS[0].n,'Misstrauensvotum gescheitert, Regierung angeschlagen',-.5);return true}
  if(!S.oppBill&&ki.length&&rnd()<.12){const pid=ki[Math.floor(rnd()*ki.length)],B=oppDraft(pid);
    if(B){S.oppBill=B;log(`${PN(pid)} bringt einen eigenen Antrag ein: „${B.t}“. Ihr müsst euch positionieren.`);
      const o=OUTLETS.map((o:any)=>({o,s:scoreRaw(o.pos,EQW,B.fx.pos)})).sort((x:any,y:any)=>y.s-x.s)[0];press(o.o.n,`${PA(pid)} legt eigenen Plan vor: „${B.t}“`,0);return true}}
  if(lead&&rnd()<.18*DM()){const w=issuesNow().filter((i:any)=>S.issues[i.id].on&&!(since(5)&&S.com?.focus?.iss===i.id)).sort((x:any,y:any)=>S.issues[y.id].sev-S.issues[x.id].sev)[0];
    if(w&&S.issues[w.id].sev>40){S.issues[w.id].sev=clamp(S.issues[w.id].sev+2,0,100);
      log(`Aktuelle Stunde: ${PN(lead)} wirft der Regierung Versagen beim Thema ${w.n} vor.`,'bad');
      press(OUTLETS[3].n,`${PA(lead)} attackiert Regierung: „Beim Thema ${w.n} passiert nichts“`,-.7)}}
  return false;
}
export function decideOpp(yes?:any){
  const B=S.oppBill;S.oppBill=null;if(!B)return;
  const v=btVote(B.fx.pos);let ok=yes;
  if(yes){const by:any={};let ys=S.res.seats[B.pid]||0;for(const id of S.res.inP){if(id===B.pid)continue;const c=id==='YOU'||S.partners.includes(id);if(c||(v.by[id]&&v.by[id].y))ys+=S.res.seats[id]}
    ok=ys>=NEED;if(!ok)log(`Trotz eurer Stimmen fehlt dem Antrag der ${PA(B.pid)} die Mehrheit.`)}
  if(B.human)versusOnBill(B.pid,!!yes,!!(yes&&ok));
  if(yes&&ok){const L:any={id:S.nid++,iss:B.iss,tpl:B.tpl||0,t:`${B.t} (Antrag ${PA(B.pid)})`,r:B.r,br:0,p:B.p,fx:B.fx,stage:'bt',left:0};
    S.partners.forEach((p:any)=>{if(score(p,B.fx.pos)<.4){S.coal=clamp(S.coal-6,0,100);log(`${PN(p)} ist empört, dass ihr mit der Opposition stimmt.`,'bad')}});
    if(!S.issues[B.iss].law)S.issues[B.iss].law=L.id;S.laws.push(L);enact(L);
    press(OUTLETS[0].n,`Überraschung im Bundestag: Regierung stimmt Antrag der ${PA(B.pid)} zu`,.5)}
  else if(!yes){const pop=Object.keys(WEIGHT).reduce((s:any,g:any)=>s+((B.fx.g||{})[g]||0)*WEIGHT[g],0);
    log(`Ihr lehnt den Antrag der ${PA(B.pid)} zu „${B.t}“ ab.`);
    if(pop>2){S.basis-=.5;press(OUTLETS[2].n,`Regierung blockiert populären Antrag der ${PA(B.pid)}`,-1)}}
}
export function fillerNews(){
  const d=poll()-(S.prev?S.prev.poll:poll());
  if(Math.abs(d)>=.6){press(OUTLETS[0].n,d>0?`Umfrage: ${S.name} legt zu`:`Umfrage: ${S.name} verliert an Zustimmung`,d>0?.3:-.3);return}
  const w=issuesNow().filter((i:any)=>S.issues[i.id].on).sort((x:any,y:any)=>S.issues[y.id].sev-S.issues[x.id].sev)[0];
  if(w&&S.issues[w.id].sev>=55){const o=OUTLETS[Object.keys(w.imp)[0]==='unt'?1:Object.keys(w.imp)[0]==='jung'?2:3];press(o.n,`${w.n}: Wann handelt die Regierung endlich?`,-.4)}
}

